import { IconVasPremium16, IconVasTop16, IconVasAuction16 } from '@cian/ui-kit';
import React from 'react';

import { IconStandard } from './icons/icon_standard';
import { EVas } from '../../types/vas';

interface IVasIconProps {
  type: EVas;
}

export function VasIcon({ type }: IVasIconProps) {
  switch (type) {
    case EVas.Auction:
      return <IconVasAuction16 color="warning_100" />;
    case EVas.Standard:
      return <IconStandard />;
    case EVas.Premium:
      return <IconVasPremium16 color="warning_100" />;
    case EVas.Top:
      return <IconVasTop16 color="warning_100" />;
    default:
      return null;
  }
}
